import {useEffect, useState, useContext} from 'react';
import {Context} from '../../context';
import {Link} from 'react-router-dom';
import {getSessionStorageField} from '../../context/contextHelper';

const HeaderMenu = () => {
  const [menuExpanded, setMenuExpanded] = useState(false);
  const [links, setLinks] = useState([]);
  const pathname = window.location.pathname.replace('/wider-web', '');
  const {token, signOut, localeText, hideMenu} = useContext(Context);
  const [mobileApp] = useState(getSessionStorageField('mobile', null));

  useEffect(() => {
    setLinks(() => {
      if (window.location.pathname.includes('rider-web/reset')) {
        // Specifically for Password Reset section
        return [];
      }
      if (!token) {
        return [
          {
            navLinkClass: 'sign-in',
            title: localeText('rw_header_nav_sign_in', 'Sign In'),
            signin: true,
            to: '/'
          }
        ];
      }

      const browserMenuItems = [
        {
          navLinkClass: 'load-funds',
          title: localeText('rw_header_nav_load_funds', 'Load Funds'),
          imgSrc: '/images/load-funds.png',
          to: '/loadfunds'
        },
        {
          navLinkClass: 'buy',
          title: localeText('rw_header_nav_purchase_passes', 'Purchase Passes'),
          imgSrc: '/images/shopping_cart.png',
          to: '/buy'
        },
        {
          navLinkClass: 'manage-cards',
          title: localeText('rw_header_nav_manage_cards', 'Manage Cards'),
          imgSrc: '/images/card.svg',
          to: '/managecards'
        },
        {
          navLinkClass: 'my-account',
          title: localeText('rw_header_nav_my_account', 'My Account'),
          imgSrc: '/images/settings.png',
          to: '/myaccount'
        }
      ];

      return [
        ...(!mobileApp ? browserMenuItems : []),
        {
          navLinkClass: 'sign-out',
          title: localeText('rw_header_nav_sign_out', 'Sign Out'),
          onClick: signOut,
          to: '/'
        }
      ];
    });
  }, [token, hideMenu, localeText, signOut]);
  return (
    <div>
      <div className='hidden lg:flex gap-10 items-center'>
        {links.map(link => {
          const {navLinkClass, signin, to, onClick, imgSrc, title} = link;

          return (
            <Link
              key={navLinkClass}
              name={navLinkClass && `nav-link-${navLinkClass}`}
              className={`nav-link-${navLinkClass} flex gap-2 items-center h-max w-full lg:w-max whitespace-nowrap ${
                !signin && 'bg-lightGray2 p-4 hover:bg-white'
              } lg:bg-inherit lg:hover:bg-inherit  lg:p-0 first:rounded-t-md last:rounded-b-md`}
              onClick={onClick}
              to={to}
            >
              {imgSrc && (
                <img
                  className='h-8 hidden xl:inline'
                  src={imgSrc}
                  alt={`${title} ${localeText(
                    'rw_header_alt_link_icon',
                    'link icon'
                  )}`}
                />
              )}
              {pathname === to && pathname !== '/' ? <b>{title}</b> : title}
            </Link>
          );
        })}
      </div>
      <div
        className='relative lg:hidden'
        onMouseLeave={() => setMenuExpanded(false)}
        onClick={() => setMenuExpanded(prev => !prev)}
      >
        <i id='bar-menu-icon' className='fa-solid fa-bars p-4 self-end'></i>
        {menuExpanded && (
          <div className='absolute text-black right-0 top-0 flex flex-col bg-white rounded-md shadow-md border'>
            <i className='fa-solid fa-bars p-4 self-end'></i>
            {menuExpanded &&
              links.map(link => {
                const {navLinkClass, to, onClick, title} = link;

                return (
                  <Link
                    key={navLinkClass}
                    className={`hover:bg-slate-300 last:rounded-b-md whitespace-nowrap p-4 w-full nav-link-${navLinkClass}`}
                    to={to}
                    onClick={() => {
                      onClick && onClick();
                    }}
                  >
                    {pathname === to && pathname !== '/' ? (
                      <b>{title}</b>
                    ) : (
                      title
                    )}
                  </Link>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderMenu;
